import React from "react";
import styled from "styled-components";
import { CompanyRyftCardFeesTab } from "./CompanyRyftCardFeesTab";
import { CompanyRyftPayoutsTab } from "./CompanyRyftPayoutsTab";
import { CompanyFeeInvoicesTab } from "./CompanyFeeInvoicesTab";

interface Props {
  companyId: string;
}

// Wraps on the space the page actually has — the admin sidebar makes a
// viewport breakpoint too late.
const Layout = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
  width: 100%;
  padding-top: 20px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  flex: 1 1 340px;

  & + & {
    flex: 2 1 480px;
  }
`;

const FullRow = styled.div`
  flex: 1 1 100%;
  min-width: 0;
`;

export const CompanyCardPaymentsTab: React.FC<Props> = ({ companyId }) => (
  <Layout>
    <Column>
      <CompanyRyftCardFeesTab companyId={companyId} />
    </Column>
    <Column>
      <CompanyRyftPayoutsTab companyId={companyId} />
    </Column>
    <FullRow>
      <CompanyFeeInvoicesTab companyId={companyId} />
    </FullRow>
  </Layout>
);
